import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

export const generateOrderInvoicePDF = async (order) => {
  // Create a temporary div to render the invoice
  const invoiceContainer = document.createElement('div');
  invoiceContainer.style.position = 'absolute';
  invoiceContainer.style.left = '-9999px';
  invoiceContainer.style.width = '800px';
  invoiceContainer.style.padding = '20px';
  invoiceContainer.style.backgroundColor = 'white';

  // Format currency
  const formatCurrency = (amount) => {
    return `৳${parseFloat(amount || 0).toLocaleString('en-BD')}`;
  };

  // Format date
  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    return dateString;
  };

  // Calculate totals
  const subtotal = parseFloat(order.totalproductamount || 0);
  const deliveryCharge = parseFloat(order.deliverycharge || 0);
  const vat = parseFloat(order.vat || 0);
  const total = parseFloat(order.totalamount || 0);

  //  ${order.ordertime || ''}

  // Generate invoice HTML
  invoiceContainer.innerHTML = `
    <div style="font-family: 'Arial', sans-serif; color: #333;">
      <!-- Header -->
      <div style="text-align: center; margin-bottom: 30px; border-bottom: 2px solid #f0f0f0; padding-bottom: 20px;">
        <h1 style="color: #556ee6; margin-bottom: 5px;">INVOICE</h1>
        <p style="color: #666; margin: 5px 0;">Order ID: #00695${order.id}</p>
        <p style="color: #666; margin: 5px 0;">Date: ${formatDate(order.orderdate)}</p>
      </div>
      
      <!-- Company & Order Info -->
      <div style="display: flex; justify-content: space-between; margin-bottom: 30px;">
        <div>
          <h3 style="color: #556ee6; margin-bottom: 10px;">From</h3>
          <p style="margin: 5px 0;"><strong>Qwik Medic</strong></p>
          <p style="margin: 5px 0;">26/27 Sher Shah Suri Road, Mohammadpur, Dhaka 1207.Bangladesh</p>
          <p style="margin: 5px 0;">Phone: +880 1623 06 06 06</p>
          <p style="margin: 5px 0;">Email: support@qwikmedic.com</p>
        </div>
        
        <div style="text-align: right;">
          <h3 style="color: #556ee6; margin-bottom: 10px;">Bill To</h3>
          <p style="margin: 5px 0;"><strong>${order.username}</strong></p>
          <p style="margin: 5px 0;">Phone: ${order.phonenumber}</p>
          <p style="margin: 5px 0;">${order.address}</p>
          ${order.notes ? `<p style="margin: 5px 0; color: #666;">Notes: ${order.notes}</p>` : ''}
        </div>
      </div>
      
      <!-- Order Details -->
      <div style="margin-bottom: 20px;">
        <h3 style="color: #556ee6; margin-bottom: 15px; border-bottom: 1px solid #f0f0f0; padding-bottom: 5px;">
          Order Details
        </h3>
        
        <!-- Order Status Badges -->
        <div style="display: flex; gap: 20px; margin-bottom: 15px;">
          
          <div>
            
            <p style="margin: 5px 0 0 0; font-size: 12px;">Payment Status: <span  
              color: ${order.paymentstatus === 'paid' ? '#34c38f' : '#f46a6a'}; font-size: 12px;">
              ${order.paymentstatus}
            </span></p>
          </div>
          
          <div>
            
            <p style="margin: 5px 0 0 0; font-size: 12px;">Payment Method: <span style="font-size: 12px;">
              ${order.paymentmethod === 'Cash_on_delivery' ? 'Cash on delivery' : 'Online'}
            </span></p>
          </div>
        </div>
      </div>
      
      <!-- Products Table -->
      <div style="margin-bottom: 30px;">
        <h3 style="color: #556ee6; margin-bottom: 15px; border-bottom: 1px solid #f0f0f0; padding-bottom: 5px;">
          Products
        </h3>
        
        <table style="width: 100%; border-collapse: collapse;">
          <thead>
            <tr style="background-color: #f8f9fa;">
              <th style="border: 1px solid #dee2e6; padding: 12px; text-align: left;">Product</th>
              <th style="border: 1px solid #dee2e6; padding: 12px; text-align: center;">Type</th>
              <th style="border: 1px solid #dee2e6; padding: 12px; text-align: center;">Qty</th>
              <th style="border: 1px solid #dee2e6; padding: 12px; text-align: center;">Unit Price</th>
              <th style="border: 1px solid #dee2e6; padding: 12px; text-align: right;">Total</th>
            </tr>
          </thead>
          <tbody>
           ${order.orderproductdata.map((product, index) => `
              <tr style="${index % 2 === 0 ? 'background-color: #f8f9fa;' : ''}">
                <td style="border: 1px solid #dee2e6; padding: 12px;">
                  <strong>${product.tytle}</strong>
                  ${product.power !== 'none' ? `<br/><small>Strength: ${product.power}</small>` : ''}
                  ${product.ptype !== 'none' ? `<br/><small>Type: ${product.ptype}</small>` : ''}
                </td>
                <td style="border: 1px solid #dee2e6; padding: 12px; text-align: center;">
                  ${product.type}
                </td>
                <td style="border: 1px solid #dee2e6; padding: 12px; text-align: center;">
                  ${product.quantity}
                </td>
                <td style="border: 1px solid #dee2e6; padding: 12px; text-align: center;">
                  ${formatCurrency(product.discountPrice)}
              
                </td>
                <td style="border: 1px solid #dee2e6; padding: 12px; text-align: right;">
                  ${formatCurrency(product.totalprice)}
                </td>
              </tr>
            `).join('')}
          </tbody>
        </table>
      </div>
      
      <!-- Summary -->
      <div style="display: flex; justify-content: flex-end;">
        <div style="width: 300px;">
          <div style="display: flex; justify-content: space-between; margin-bottom: 10px;">
            <span>Subtotal:</span>
            <span>${formatCurrency(subtotal)}</span>
          </div>
          
          ${vat > 0 ? `
            <div style="display: flex; justify-content: space-between; margin-bottom: 10px;">
              <span>VAT (${order.vat}%):</span>
              <span>${formatCurrency(vat)}</span>
            </div>
          ` : ''}
          
          <div style="display: flex; justify-content: space-between; margin-bottom: 10px;">
            <span>Delivery Charge:</span>
            <span>${formatCurrency(deliveryCharge)}</span>
          </div>
          
          <div style="border-top: 2px solid #556ee6; padding-top: 10px; margin-top: 10px;">
            <div style="display: flex; justify-content: space-between; font-size: 18px; font-weight: bold;">
              <span>Total Amount:</span>
              <span>${formatCurrency(total)}</span>
            </div>
          </div>
          
          ${order.paidamount > 0 ? `
            <div style="display: flex; justify-content: space-between; margin-top: 10px; padding-top: 10px; border-top: 1px dashed #ddd;">
              <span>Paid Amount:</span>
              <span style="color: #34c38f;">${formatCurrency(order.paidamount)}</span>
            </div>
          ` : ''}
          
          ${order.dueamount > 0 ? `
            <div style="display: flex; justify-content: space-between; margin-top: 5px;">
              <span>Due Amount:</span>
              <span style="color: #f46a6a;">${formatCurrency(order.dueamount)}</span>
            </div>
          ` : ''}
        </div>
      </div>
      
     
    </div>
  `;

  // Add to document
  document.body.appendChild(invoiceContainer);

  try {
    // Convert to canvas then to PDF
    const canvas = await html2canvas(invoiceContainer, {
      scale: 2,
      useCORS: true,
      logging: false,
      backgroundColor: '#ffffff'
    });

    // Create PDF
    const imgData = canvas.toDataURL('image/png');
    const pdf = new jsPDF('p', 'mm', 'a4');
    const imgWidth = 210; // A4 width in mm
    const pageHeight = 295; // A4 height in mm
    const imgHeight = (canvas.height * imgWidth) / canvas.width;

    let heightLeft = imgHeight;
    let position = 0;

    pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
    heightLeft -= pageHeight;

    // Add additional pages if needed
    while (heightLeft >= 0) {
      position = heightLeft - imgHeight;
      pdf.addPage();
      pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;
    }

    // Save PDF
    pdf.save(`invoice-00695${order.id}-${order.username}.pdf`);

  } catch (error) {
    console.error('Error generating PDF:', error);
    throw error;
  } finally {
    // Clean up
    document.body.removeChild(invoiceContainer);
  }
};